export const DESKTOP_SIDEBAR_COLLAPSED_STORAGE_KEY = "layout.desktopSidebarCollapsed";

